import { Navigate, useLocation } from 'react-router-dom'
import { useContext } from 'react'
import AuthContext from '../context/AuthContext';
import ErrorBoundary from '../components/ErrorBoundary';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!user) return <Navigate to='/login' replace />;

    // key=pathname resets the boundary on every navigation so a crash in one
    // page never prevents access to other pages.
    return (
        <ErrorBoundary key={location.pathname}>
            {children}
        </ErrorBoundary>
    );
};

export default PrivateRoute;